import { takeLatest, all, call, fork, put } from "redux-saga/effects";
import { userWorkspaceManager } from "../../constants/actionTypes";
import {
  setUserWorkspaceManagerList,
  setUserWorkspaceManagerListError,
  setGetUserWorkspaceListLoading,
  setUserWorkspaceLabTimer,
} from "../../store/actions";
import {
  fetchWorkspaceList,
  fetchWorkspaceLabTimer,
} from "../api/userWorkspaceManager";
import {
  toasterFlags,
  errorWentWrong,
} from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { statusCode } from "../../constants/apis/apiStatus";

function* getUserWorkspaceDashboardList({ data }) {
  yield put(setGetUserWorkspaceListLoading(true));
  try {
    const workspaceListData = yield call(fetchWorkspaceList, data?.url);
    yield put(setGetUserWorkspaceListLoading(false));
    if (workspaceListData?.status === statusCode.Ok200) {
      yield put(setUserWorkspaceManagerList(workspaceListData));
      if (workspaceListData?.data?.[0]?.id && data?.callback) {
        data?.callback?.(false);
      } else {
        data?.callback?.(true);
      }
    } else {
      toastNotification(toasterFlags.WARN, workspaceListData?.data?.message);
      yield put(setUserWorkspaceManagerListError(workspaceListData));
    }
  } catch (err) {
    yield put(setUserWorkspaceManagerListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setGetUserWorkspaceListLoading(false));
}

function* getUserWorkspaceLabTimerFunc({ data }) {
  try {
    const workspaceListData = yield call(fetchWorkspaceLabTimer, data);
    if (workspaceListData?.status === statusCode.Ok200) {
      yield put(setUserWorkspaceLabTimer(workspaceListData));
    } else {
      toastNotification(toasterFlags.WARN, workspaceListData?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
}

export function* userWorkspaceManagerRootSaga() {
  yield takeLatest(
    userWorkspaceManager.GET_USER_WORKSPACE_DASHBOARD_LIST,
    getUserWorkspaceDashboardList
  );
  yield takeLatest(
    userWorkspaceManager.GET_USER_WORKSPACE_LAB_TIMER,
    getUserWorkspaceLabTimerFunc
  );
}

export default function* rootSaga() {
  yield all([fork(userWorkspaceManagerRootSaga)]);
}
